import * as DropdownMenu from '@radix-ui/react-dropdown-menu'
import cx from 'classnames'

import Image from 'common/components/image'

import { Options } from './interfaces'

type Props = Pick<Options, 'label' | 'logoUrl'> & {
  isDisabled?: boolean
  alt: string
  onSelect?: () => void
}

const IntegrationItem = ({
  logoUrl,
  alt,
  label,
  isDisabled = false,
  onSelect,
}: Props) => {
  return (
    <DropdownMenu.Item
      onSelect={isDisabled ? undefined : onSelect}
      disabled={isDisabled}
      className={cx(
        'group flex items-center text-base-700 text-sm font-normal py-2 px-4 -mx-4 outline-none',
        {
          'cursor-not-allowed pointer-events-auto opacity-50': isDisabled,
          'cursor-pointer hover:bg-gold-300': !isDisabled,
        },
        'updated-component'
      )}
    >
      <div
        className={cx(
          'p-1 flex justify-center items-center h-11 w-11 border-gold-400 border mr-2',
          {
            'group-hover:border-gold-500': !isDisabled,
          }
        )}
      >
        <Image src={logoUrl} alt={alt} isResponsive />
      </div>
      <span className="max-w-35 truncate">{label}</span>
    </DropdownMenu.Item>
  )
}

export default IntegrationItem
